import { combineReducers, configureStore } from "@reduxjs/toolkit";
import filterReducer from "./filterSlice";
import entityReducer from "./entitySlice";
import focusReducer from "./focusSlice";
import permissionReducer from "./permissionSlice";
import companyProfileReducer from "./companySlice";
import userReducer from "../userSlice"; 
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const companyProfilePersistConfig = {
  key: 'companyProfile',
  storage,
};

const PermissionsPersistConfig = {
  key: 'permissions',
  storage,
};


const userPersistConfig = {
  key: 'user',
  storage,
};

const rootReducer = combineReducers({
  companyProfile: persistReducer(companyProfilePersistConfig, companyProfileReducer),
  filters: filterReducer,
  focus: focusReducer,
  entity: entityReducer,
  permissions: persistReducer(PermissionsPersistConfig, permissionReducer),
  user: persistReducer(userPersistConfig, userReducer), 
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;


export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;